module.exports = __webpack_public_path__ + "static/media/confirma_email.549958c0.png";